import React, { useCallback } from 'react';
import { MarkButton, MarkInput, MarkSelect, MarkLabel } from '../../components/MarkControls';
import * as layout from '../../components/markLayout.module.css';
import useContactSearchParams from '../../hooks/useContactSearchParams';

const ContactSearchBar: React.FC = () => {
    const { params, setQuery, setIsDemo } = useContactSearchParams();
    const handleSubmit = useCallback(
        (event: React.FormEvent<HTMLFormElement>) => {
            event.preventDefault();
            const data = new FormData(event.currentTarget);
            setQuery(String(data.get('q') || '').trim());
        },
        [setQuery]
    );
    return (
        <div className={layout.fieldGrid} style={{ width: '100%' }}>
            <form key={params.q} onSubmit={handleSubmit} className={layout.searchForm}>
                <div className={layout.field}>
                    <MarkLabel htmlFor="mark-contact-search">Search contacts</MarkLabel>
                    <MarkInput
                        id="mark-contact-search"
                        name="q"
                        type="search"
                        defaultValue={params.q}
                        placeholder="Email, name, or Hero user ID"
                    />
                </div>
                <MarkButton type="submit" variant="primary" size="regular">
                    Search
                </MarkButton>
            </form>
            <div className={layout.field}>
                <MarkLabel htmlFor="mark-contact-demo-filter">Contact type</MarkLabel>
                <MarkSelect
                    id="mark-contact-demo-filter"
                    value={params.is_demo ? 'true' : 'all'}
                    onChange={(event) => setIsDemo(event.currentTarget.value === 'true')}
                >
                    <option value="all">All contacts</option>
                    <option value="true">Demo only</option>
                </MarkSelect>
            </div>
        </div>
    );
};
export default ContactSearchBar;
